<style scoped lang="scss">
.cons{
  display: none;
}
.service_chan{
  margin-bottom: 20px;
  display: flex;
  overflow: auto;
  justify-content: space-around;
  li{
    width: 190px;
    height: 188px;
    //margin-right:100px;
    background: url("../../assets/img/产品及服务/fuwu.jpg") no-repeat!important;
    background-size: auto!important;
    .img{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    p{
      font-size: 16px;
      color:#4e4e4e;
      margin-bottom: 10px;
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .liaojie{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      color:#959595;
      cursor: pointer;
    }
  }
  li:hover{
    background: url("../../assets/img/产品及服务/fuwu1.jpg") no-repeat!important;
    background-size: auto!important;
    p{
      color: #fff;
    }
    .liaojie{
      color: #fff;
    }
  }
  li:last-child{
    margin-right: 0;
  }
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .cons{
    display: block!important;
  }
  .con{
    display: none!important;
  }
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.required{
  margin-top: 50px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
//.effect-lists1{
//  //display: block!important;
//  justify-content: center;
//  flex-wrap:wrap;
//  overflow: auto;
//}
.compose-type1{
  padding-bottom: 50px;
  //background: url("../../assets/img/产品及服务/基因调控/基因编辑/ys_bg.png") no-repeat;
  //background-size: 100% 100%;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner con" v-if="!$route.meta.invisibles">
      <img src="@/assets/img/产品及服务/全基因组合成/质粒抽提/banner3.jpg" class="img-fluid" alt="擎科生物-质粒抽提">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons" v-if="!$route.meta.invisibles">
      <img src="@/assets/img/产品及服务/全基因组合成/质粒抽提/banner3_2.jpg" class="img-fluid" alt="擎科生物-质粒抽提">
      <div class="info"></div>
    </div>
    <section v-if="!$route.meta.invisibles">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc">质粒是细胞内的一种环状的小分子 DNA，是进行 DNA 重组的常用载体。在分子生物学实验中，通常将目的基因插入到质粒的多克隆位点上，构建新的重组质粒，目的基因可以随质粒载体进入到受体细胞中。利用质粒上的元件，可以在受体细胞中进行复制和表达，随宿主细胞的分裂，转移到子代细胞中。不同的下游实验，对质粒的提取量和纯度也会有所差别。获得高品质的质粒对下游实验起到非常重要的作用。</p>
        <p class="desc" style="margin-top: 30px;text-indent: 0"><span style="font-weight:bold;">科研级别：</span>获取更大量的质粒（默认浓度 1000 ng/μL）;</p>
        <p class="desc" style="text-indent: 0"><span style="font-weight:bold;">转染级别：</span>去除内毒素、提高超螺旋比例，可以直接转染到细胞，并提高转染效率及表达量。</p>
      </div>
      <div class="container">
        <en-title title="服务流程" enTitle="Service Process"></en-title>
        <div class="container con">
          <div style="width: fit-content;margin-left: auto;margin-right: auto;"><img src="@/assets/img/产品及服务/全基因组合成/质粒抽提/6.jpg" alt="擎科生物-质粒抽提服务流程"></div>
          <!-- <div style="width: fit-content;margin-left: auto;margin-right: auto;margin-top: 10px;"><img src="@/assets/img/产品及服务/全基因组合成/质粒抽提/7.jpg" alt="擎科生物-质粒抽提服务流程"></div> -->
          <!-- <div style="width: fit-content;margin-left: auto;margin-right: auto;margin-top: 10px;"><img src="@/assets/img/产品及服务/全基因组合成/质粒抽提/5.jpg" alt="擎科生物-质粒抽提服务流程"></div> -->
        </div>
        <div class="cons" style="margin-top: 20px;">
          <div style="width: 100%;margin-left: auto;margin-right: auto;"><img src="@/assets/img/产品及服务/全基因组合成/质粒抽提/6_2.jpg" class="img-fluid" alt="擎科生物-质粒抽提服务流程"></div>
          <!-- <div style="width: 100%;margin-left: auto;margin-right: auto;margin-top: 10px;"><img src="@/assets/img/产品及服务/全基因组合成/质粒抽提/7_2.jpg" class="img-fluid" alt="擎科生物-质粒抽提服务流程"></div> -->
          <!-- <div style="width: 100%;margin-left: auto;margin-right: auto;margin-top: 10px;"><img src="@/assets/img/产品及服务/全基因组合成/质粒抽提/5_2.jpg" class="img-fluid" alt="擎科生物-质粒抽提服务流程"></div> -->
        </div>
      </div>

      <div class="compose-type1">
        <div class="container">
          <en-title title="服务内容" enTitle="Service Details"></en-title>
          <gene-detail-table :tips="tableTips" :tableColumn="tableColumn" :tableData="tableData" :tableSpanMethod="tableSpanMethod"></gene-detail-table>
        </div>
      </div>
      <div class="container con">
        <en-title title="应用领域" enTitle="Application"></en-title>
        <div class="neirong">
          <div class="neirong1">
            <h3>1.常规分子生物学实验</h3>
            <p class="desc" style="text-indent: 0">如果下游用于酶切、测序、亚克隆、转化和基因表达等常规分子生物学实验，手提和试剂盒提取制备的质粒均能达到需求。</p>
          </div>
          <div class="neirong1" style="margin-top: 20px;">
            <h3>2.质粒转染或显微注射等实验</h3>
            <p class="desc" style="text-indent: 0">如果下游需要将质粒转染至细胞中或者显微注射到实验动物体内，则要求质粒的内毒素含量和超螺旋比例达到一定的标准。</p>
            <p class="desc" style="text-indent: 0">内毒素会影响质粒的转染效率和转染后细胞状态，质粒超螺旋比例越高，其转染效率及表达量也会越高。</p>
          </div>
        </div>
      </div>
      <div class="container cons">
        <en-title title="应用领域" enTitle="Application"></en-title>
        <div class="neirong">
          <div class="neirong1">
            <p>1.常规分子生物学实验</p>
            <p class="desc">如果下游用于酶切、测序、亚克隆、转化和基因表达等常规分子生物学实验，手提和试剂盒提取制备的质粒均能达到需求。</p>
          </div>
          <div class="neirong1" style="margin-top: 20px;">
            <p>2.质粒转染或显微注射等实验</p>
            <p class="desc">如果下游需要将质粒转染至细胞中或者显微注射到实验动物体内，则要求质粒的内毒素含量和超螺旋比例达到一定的标准。</p>
            <p class="desc">内毒素会影响质粒的转染效率和转染后细胞状态，质粒超螺旋比例越高，其转染效率及表达量也会越高。</p>
          </div>
        </div>
      </div>
      <div class="container">
        <en-title title="相关服务" enTitle="Related Services"></en-title>
        <div class="container" style="width: 100%!important;">
          <div class="con">
            <ul class="effect-lists service_chan">
              <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
                <img :src="`/static/img/fenzi_${item.img}${currentType===index ? '' : '_active'}.png`" >
                <p style="margin-top: 10px;">{{item.name}}</p>
                <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
              </li>
            </ul>
          </div>
          <div class="cons" style="margin-top: 20px;">
            <ul class="effect-lists service_chan">
              <li v-for="(item, index) in types" :key="index" class="pointer"   @click="$router.push(item.ref)">
                <img :src="`/static/img/fenzi_${item.img}${currentType===index ? '' : '_active'}.png`" style="width: 55px;height: 55px;">
                <p style="margin-top: 10px;">{{item.name}}</p>
                <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 订购与咨询 -->
      <div class="container">
          <new-consult type="gene" :typeList="['orderOnline','telePhone','download','email']"></new-consult>
      </div>
      <!-- <div class="container">
        <qk-consult type="Virus2"/>
      </div> -->
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
import EnTitle from '@/components/EnTitle'
import GeneDetailTable from './gene-components/geneDetailTable'
export default {
  components:{
    bread ,
    EnTitle ,
    GeneDetailTable
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      tableColumn:[
        {
          label: '业务分类',
          prop: 'serviceType',
        },
        {
          label: '抽提量',
          prop: 'extractionVolume',
        },
        {
          label: '生产周期(工作日)',
          prop: 'productionCycle',
        },
        {
          label: '基因合成+大提\n(大提周期)*',
          prop: 'bigLiftCycle',
        },
        {
          label: '业务分类',
          prop: 'serviceTypeRep',
          width: 120,
          html: true,
        },
        {
          label: '抽提量',
          prop: 'extractionVolumeRep',
        },
        {
          label: '生产周期(工作日)',
          prop: 'productionCycleRep',
        },
        {
          label: '基因合成+大提\n(大提周期)*',
          prop: 'bigLiftCycleRep',
        },
      ],
      tableData:[
        {
          serviceType: '科研级别',
          extractionVolume: '100μg',
          productionCycle: '5',
          bigLiftCycle: '3',
          serviceTypeRep: `<p>转染级别</p>（<span style="white-space: nowrap;">＜0.1Eu/μg</span>、<span style="white-space: nowrap;">＜0.01Eu/μg</span>、<span style="white-space: nowrap;">＜0.005Eu/μg）</span>`,
          extractionVolumeRep: '100μg',
          productionCycleRep: '5',
          bigLiftCycleRep: '3',
        },
        {
          serviceType: '',
          extractionVolume: '200μg',
          productionCycle: '5',
          bigLiftCycle: '3',
          serviceTypeRep: '',
          extractionVolumeRep: '200μg',
          productionCycleRep: '5',
          bigLiftCycleRep: '3',
        },
        {
          serviceType: '',
          extractionVolume: '500μg',
          productionCycle: '7',
          bigLiftCycle: '5',
          serviceTypeRep: '',
          extractionVolumeRep: '500μg',
          productionCycleRep: '7',
          bigLiftCycleRep: '5',
        },
        {
          serviceType: '',
          extractionVolume: '1mg',
          productionCycle: '7',
          bigLiftCycle: '5',
          serviceTypeRep: '',
          extractionVolumeRep: '1mg',
          productionCycleRep: '7',
          bigLiftCycleRep: '5',
        },
        {
          serviceType: '',
          extractionVolume: '2mg',
          productionCycle: '8',
          bigLiftCycle: '6',
          serviceTypeRep: '',
          extractionVolumeRep: '2mg',
          productionCycleRep: '8',
          bigLiftCycleRep: '6',
        },
        {
          serviceType: '',
          extractionVolume: '3mg',
          productionCycle: '9',
          bigLiftCycle: '7',
          serviceTypeRep: '',
          extractionVolumeRep: '3mg',
          productionCycleRep: '9',
          bigLiftCycleRep: '7',
        },
        {
          serviceType: '',
          extractionVolume: '4mg',
          productionCycle: '10',
          bigLiftCycle: '8',
          serviceTypeRep: '',
          extractionVolumeRep: '4mg',
          productionCycleRep: '10',
          bigLiftCycleRep: '8',
        },
        {
          serviceType: '',
          extractionVolume: '5mg',
          productionCycle: '11',
          bigLiftCycle: '9',
          serviceTypeRep: '',
          extractionVolumeRep: '5mg',
          productionCycleRep: '11',
          bigLiftCycleRep: '9',
        },
        {
          serviceType: '',
          extractionVolume: '10mg',
          productionCycle: '13',
          bigLiftCycle: '11',
          serviceTypeRep: '',
          extractionVolumeRep: '10mg',
          productionCycleRep: '13',
          bigLiftCycleRep: '11',
        },
        {
          serviceType: '',
          extractionVolume: '20mg',
          productionCycle: '13',
          bigLiftCycle: '11',
          serviceTypeRep: '',
          extractionVolumeRep: '20mg',
          productionCycleRep: '15',
          bigLiftCycleRep: '13',
        },
        {
          serviceType: '',
          extractionVolume: '50mg',
          productionCycle: '15',
          bigLiftCycle: '13',
          serviceTypeRep: '',
          extractionVolumeRep: '50mg',
          productionCycleRep: '17',
          bigLiftCycleRep: '15',
        },
        {
          serviceType: '',
          extractionVolume: '100mg',
          productionCycle: '18',
          bigLiftCycle: '16',
          serviceTypeRep: '',
          extractionVolumeRep: '100mg',
          productionCycleRep: '19',
          bigLiftCycleRep: '17',
        },
        
      ],
      tableTips: {
        text: '*以擎科合成的质粒当模板做质粒抽提，周期可节约两天。',
        style: {
          'text-align': 'center',
          'margin-top': '10px',
        }
      },
      types: [
        {name: '基因合成', img: '2', ref: '/tec/gen_compose'},
        {name: '引物合成', img: '1', ref: '/tec/compose'},
        {name: '基因检测', img: '6', ref: '/products/Gene'},
        {name: '常规分子项目', img: '5', ref: '/products/Conventional_molecular_project'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    tableSpanMethod({ row, column, rowIndex, columnIndex }) {  //表格合并行
      if (columnIndex === 0 || columnIndex === 4) {
        return {
            rowspan: rowIndex === 0 ? 12 : 0,
            colspan: rowIndex === 0 ? 1 : 0
        }
      }
    },
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Plasmid_Extraction.vue